import React, { useState } from "react";
import { Card, Collapse, ListGroup, ListGroupItem } from "react-bootstrap";
import {
    UserInvitation,
    UserInvitationsData,
    UserInvitationsVariables
} from "../../../models/types";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_PENDING_USER_INVITATIONS } from "../../../graphql/queries";

export const Invitations = () => {
    const [fetched, updateFetched] = useState(false);
    const [showUsedInvitations, updateShowUsedInvitations] = useState(false);
    const [showPendingInvitations, updateShowPendingInvitations] =
        useState(true);

    const { data: { getInvitations } = {} } = useQuery<
        UserInvitationsData,
        UserInvitationsVariables
    >(GET_PENDING_USER_INVITATIONS, { variables: { pending: true } });

    const [
        getUsedInvitations,
        // @ts-ignore
        { data: { getInvitations: usedInvitations } = {} }
    ] = useLazyQuery(GET_PENDING_USER_INVITATIONS, {
        variables: { pending: false }
    });

    const pendingInvitationItems = getInvitations?.map(
        (invitation: UserInvitation, index: number) => (
            <ListGroupItem key={index} variant="primary">
                <span>
                    {invitation.email} expires at {invitation.dateExpired}
                </span>
            </ListGroupItem>
        )
    );

    const usedInvitationItems = usedInvitations?.map(
        (invitation: UserInvitation, index: number) => (
            <ListGroupItem key={index} variant="success">
                {invitation.email} attached to user{" "}
                {invitation.user.displayName} ({invitation.user.id})
            </ListGroupItem>
        )
    );

    const onUsedClick = () => {
        if (!fetched) {
            getUsedInvitations();
            updateFetched(true);
        }
        updateShowUsedInvitations(!showUsedInvitations);
    };

    return (
        <>
            <Card className="inner-card text-contrast m-3 p-0 mouseHover">
                <Card.Header
                    onClick={() =>
                        updateShowPendingInvitations(!showPendingInvitations)
                    }
                >
                    Pending Invitations
                </Card.Header>
                <Collapse
                    in={
                        showPendingInvitations &&
                        pendingInvitationItems !== undefined
                    }
                >
                    <div>
                        <Card.Body>
                            <ListGroup>{pendingInvitationItems}</ListGroup>
                        </Card.Body>
                    </div>
                </Collapse>
            </Card>
            <Card className="inner-card text-contrast m-3 p-0 mouseHover">
                <Card.Header onClick={onUsedClick}>
                    Used Invitations
                </Card.Header>
                <Collapse in={showUsedInvitations && usedInvitationItems}>
                    <div>
                        <Card.Body>
                            <ListGroup>{usedInvitationItems}</ListGroup>
                        </Card.Body>
                    </div>
                </Collapse>
            </Card>
        </>
    );
};
